import { Modal } from "antd";
import Images from "./../../../../asset/exportImages";

const MDCompanyInfo = ({ open, handleCancel, isMobile }) => {
  const info = [
    { title: 'Mã số thuế:', value: '0102385623', icon: Images.ICMst },
    { title: 'Địa chỉ:', value: 'Tầng 5-6, tòa nhà MB, số 21 Cát Linh, Phường Ô Chợ Dừa, Thành phố Hà Nội', icon: Images.ICAddress },
    { title: 'Email:', value: 'info@mic.vn', icon: Images.ICMail },
  ]

  return (
    <Modal
      title={<span style={{ fontSize: 18 }}>Thông tin công ty bảo hiểm</span>}
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={isMobile ? "100%" : 600}
      centered={!isMobile}
      className={`company-info-modal ${isMobile ? 'company-info-modal-mobile' : ''}`}
    >
      <div style={{ padding: '20px 0', borderTop: '1px solid #D9D9D9', marginTop: 15 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 15, marginBottom: 15 }}>
          <div style={{
            backgroundColor: '#ffffff',
            boxShadow: '0px 1px 1px 0px #00000017, 0px 2px 1px 0px #0000000d, 0px 3px 1px 0px #00000003, 0px 5px 1px 0px #00000000',
            borderRadius: 8,
            border: '1px solid #F0F2F5',
            padding: 8,
            display:'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: "50px",
            width: "80px"
          }}>
            <img src={Images.LogoMIC}  alt="mic-logo" width={60} />
          </div>
          <b style={{ fontSize: 20 }}>Tổng Công ty Cổ phần Bảo hiểm Quân đội</b>
        </div>
        <div style={{ display: 'grid', gap: 20 }}>
          {info.map((item, index) => (
            <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ display: 'flex', gap: 12, color: '#646D69', alignItems: 'center' }}>
                <div style={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={item.icon} width={20} alt="company-info-icon" />
                </div>
                <div style={{ fontSize: 15 }}>{item.title}</div>
              </div>
              <div style={{ fontWeight: 600, textAlign: 'right', maxWidth: '65%', color: '#343A40', fontSize: 16 }}>{item.value}</div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default MDCompanyInfo;
